/// <reference path="../../../app.definition.ts" />

import angular from "angular";
import { Subject } from "@common/model/subject";
export class CrProfilePopupController {
  subject: Subject;

  static $inject = ["$uibModalInstance", "subject"];
  constructor(
    $uibModalInstance,
    subject
  ) {
    var crProfilePopupVm: any = this;

    crProfilePopupVm.subject = subject;

    crProfilePopupVm.dismiss = () => {
      $uibModalInstance.dismiss();
    }

    crProfilePopupVm.onSave = () => {
      // do something
    }

    crProfilePopupVm.onCancel = () => {
      // do something
    }
  }
}


angular.module('eCareVault.common.popUp')
  .controller('CrProfilePopupController', CrProfilePopupController);
